import {__} from "./__";

export const getInvoiceTypes = () => {
    return {
        regular: __('Ostrá faktúra'),
        proforma: __('Zálohová faktúra'),
        cancel: __('Dobropis'),
    };
};
